// extracted by mini-css-extract-plugin
export default {"container":"DeleteConfirmModalBody_container__46v5i","iconSection":"DeleteConfirmModalBody_iconSection__-P61p","buttonSection":"DeleteConfirmModalBody_buttonSection__7f07y"};